import { usePrismicDocumentByID } from '@prismicio/react';
import React, { PropsWithChildren } from 'react';
import { TeamMember } from './team-member';

export interface ConnectedTeamMemberProps {
  id: string;
}

export const ConnectedTeamMember: React.FunctionComponent<
  PropsWithChildren<ConnectedTeamMemberProps>
> = ({ id }) => {
  const [document] = usePrismicDocumentByID(id);

  if (!document) {
    return null;
  }

  const { data } = document;

  return (
    <TeamMember
      image={data.image.url}
      name={data.full_name}
      title={data.job_title}
      linkedIn={data.linkedin.url}
      color={data.color}
      invertedTextColor={data.inverted_text_colors}
    />
  );
};
